<template>
  <div class="loading-all-box">
    <a-spin tip="Loading...">
      <div class="spin-content">

      </div>
    </a-spin>
  </div>
</template>

<script>
  export default {
    name: 'Loading'
  }
</script>

<style scoped>
  .spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;

  }
  .loading-all-box{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

  }
</style>
